qtee.customDesign = window.qtee.customDesign || {};
/**
 * Element factory
 * @requires {@link https://github.com/AliasIO/Raphael.FreeTransform| Free Transform plugin for Raphael js }
 *
 */
qtee.customDesign.elementFactory = (function () {

	var _plugins = {};

	return {
		createElement: function (model, paper, callback) {

			var freetransformOptions = qtee.customDesign.settings.freetransform.options;

			// check if background, set drag to false
			if (model.get('IsBackground') || model.get('ZOrder') === 0) {
				freetransformOptions.drag = false;
			} else {
				freetransformOptions.drag = 'self';
			}

			return _plugins[model.type](model, paper, {
				freeTransform: JSON.parse(JSON.stringify(freetransformOptions)),
				callback: callback
			});

		},
		addPlugin: function (type, p) {

			_plugins[type] = p;

		}
	};

})();
